import { render, staticRenderFns } from "./TransactionProfileLocationInfoDetails.vue?vue&type=template&id=5465aef3&scoped=true&"
import script from "./TransactionProfileLocationInfoDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionProfileLocationInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransactionProfileLocationInfoDetails.vue?vue&type=style&index=0&id=5465aef3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465aef3",
  null
  
)

export default component.exports